import type { JSX } from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CompanyUserActions } from './CompanyUserActions';
import { roleBadgeLabel, roleColors } from '../utils/company-user.utils';
import type { CompanyUser } from '../types/company-admin.types';

export interface CompanyUserCardProps {
  user: CompanyUser;
  currentUserId?: string | undefined;
  onEdit: (user: CompanyUser) => void;
}

export function CompanyUserCard({
  user,
  currentUserId,
  onEdit,
}: CompanyUserCardProps): JSX.Element {
  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">{user.fullName}</p>
            <p className="text-sm text-muted-foreground">{user.email}</p>
          </div>
          <div className="flex items-center gap-2">
            <Badge variant={user.isActive ? 'default' : 'destructive'}>
              {user.isActive ? 'Active' : 'Inactive'}
            </Badge>
            <CompanyUserActions
              user={user}
              onEdit={onEdit}
              isCurrentUser={user.id === currentUserId}
            />
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-1">
          {user.roles.map((role) => (
            <Badge key={role} variant={roleColors[role] ?? 'outline'}>
              {roleBadgeLabel(role)}
            </Badge>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
